import { ChartTypes } from '../models/chart.model';

const log10 = Math.log(10);
const calculatePercent = (percent: number, value: number) => (percent / 100) * value;
const roundUpToNearest = (roundToValue: number, value: number) =>
  Math.ceil(value / roundToValue) * roundToValue;

const getMaxValue = (value) => {
  const defaultBufferPercentage = 25;
  const maxValueWithBuffer = value + calculatePercent(defaultBufferPercentage, value);

  if (maxValueWithBuffer < 1) {
    return roundUpToNearest(1, maxValueWithBuffer);
  }

  if (maxValueWithBuffer > 1) {
    const exponentOfTen = Math.ceil(Math.log(maxValueWithBuffer) / log10);
    return roundUpToNearest(Math.pow(10, exponentOfTen - 1), maxValueWithBuffer);
  }

  return maxValueWithBuffer;
};

const setEmptyChartMax = (chartType: ChartTypes) => {
  if (chartType === 'percentage') {
    return 100;
  }

  return 5;
};

const setChartMax = (maxValue: number, chartType: ChartTypes) => {
  let value;

  switch (chartType) {
    case 'percentage':
      value = 100;
      break;
    case 'time':
      // Return undefimed and let echarts handle the max
      value = undefined;
      break;
    default:
      value = getMaxValue(maxValue);
      break;
  }

  return value;
};

const yAxisMaxValue = (maxValue: number, chartType: ChartTypes) => {
  if (maxValue === 0) {
    return setEmptyChartMax(chartType);
  }

  return setChartMax(maxValue, chartType);
};

export default yAxisMaxValue;
